import React, { ChangeEvent, CSSProperties } from 'react';
import { IStyle } from 'Styles';
import SelectInput, { IOption } from './selectInput';
import './styles.scss';
export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  inputStyle?: CSSProperties;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onFocus?: (e: ChangeEvent<HTMLInputElement>) => void;
  value?: string | number;
  inputType?: React.HTMLInputTypeAttribute;
  name?: string;
  options?: IOption[];
  errorMessage?: string;
  placeHolder?: string;
  containerStyle?: React.CSSProperties;
  readOnly?: boolean;
}

const Input = (props: Props) => {
  const {
    value,
    onChange,
    onFocus,
    inputStyle,
    inputType = 'text',
    name,
    options,
    errorMessage,
    placeHolder,
    containerStyle,
    readOnly = false,
  } = props;
  const { className, title, ...rest } = props;
  return (
    <div id='input-wrapper' style={containerStyle || styles.inputContainer}>
      {inputType == 'select' ? (
        <SelectInput
          options={options}
          style={{ ...styles.input, ...inputStyle }}
          className={className}
          onChange={onChange}
          {...rest}
        />
      ) : (
        <input
          id={`input-${title}`}
          name={name}
          type={inputType}
          style={{ ...styles.input, ...inputStyle }}
          value={value}
          onChange={onChange}
          placeholder={placeHolder}
          onFocus={onFocus}
          className={className ? className + ' no-arrow' : 'no-arrow'}
          title={title}
          readOnly={readOnly}
          {...rest}
        />
      )}
      {errorMessage && <div id={`input-errormsg-${errorMessage}`} style={styles.errorMessage}>{errorMessage}</div>}
    </div>
  );
};

const styles: IStyle = {
  inputContainer: {
    width: '100%',
  },
  input: {
    width: '100%',
  },
  errorMessage: {
    marginLeft: '1%',
    display: 'flex',
    width: '100%',
    color: 'red',
    fontSize: '0.9rem',
  },
  requiredLabel: {
    color: 'red',
    fontSize: '0.9rem',
  },
};

export default Input;
